import React from 'react';
import { useState, useEffect } from "react";
import apiAdm from '../../../services/apiAdm';
import apiAcbr from '../../../services/apiAcbr';
import { SweetAlertSuccess, SweetAlertError } from '../../../components/sweetAlert/swetAlert.jsx';
import base64 from 'base-64';
import { useNavigate } from "react-router-dom";
import { FiSave, FiXCircle } from "react-icons/fi";

function CrudCertificado() {

    const navigate = useNavigate();

    const [senha, setSenha] = useState('');
    const [file, setFile] = useState();
    const [certNome, setCertNome] = useState('');
    const [certData, setCertData] = useState('');
    const [vencto, setVencto] = useState('');


    const handleFileUpload = (e) => {
        setFile(e.target.files[0]);
    };

    function Validar() {
        if (senha == '') {
            SweetAlertError({ texto: 'Falta informar a senha do certificado.' })
            return false;
        };
        console.log(file);
        if (file === undefined) {
            SweetAlertError({ texto: 'Falta informar o arquivo pfx.' })
            return false;
        };
        return true;
    };

    function Testar() {
        if (Validar() === false) {
            return;
        }
        const senhaBase64 = base64.encode(senha);
        apiAcbr.post('/validarCertificadoA1', file,
            {
                headers:
                {
                    'Content-Type': 'application/octet-stream',
                    'x-senha': '',
                    'x-senha64': senhaBase64,
                    'x-cnpj': localStorage.getItem('cnpjEmpresa')
                }
            })
            .then((resp) => {
                console.log('Teste: ', resp);
                if (resp.data.status == 'OK') {
                    SweetAlertSuccess({ texto: 'Certificado validado com sucesso' });

                    // let dtExp = new Intl.DateTimeFormat('pt-BR',
                    //     {
                    //         year: 'numeric',
                    //         month: 'numeric',
                    //         day: 'numeric',
                    //         hour: 'numeric',
                    //         minute: 'numeric',
                    //     }).format(new Date(resp.data.vencto));

                    setCertNome(resp.data.razao);
                    // setCertData(dtExp);
                    setVencto(resp.data.vencto);

                } else {
                    SweetAlertError({ texto: resp.data.message });

                }
            })
            .catch((erro) => {
                SweetAlertError({ texto: erro });

            })
    }

    useEffect(() => {
        setCertNome('');
        setCertData('');
        setVencto('');
        apiAdm.get('/entidade/' + localStorage.getItem('idEmpresa'))
            .then((resp) => {
                console.log(resp.data.data);
                setCertNome(resp.data.data.certRazao);
                let dtExp = new Intl.DateTimeFormat('pt-BR',
                    {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                    }).format(new Date(resp.data.data.certDtVencto));

                setCertData(dtExp);
            });

    },
        []);

    function Cancelar() {
        window.history.back();
    };

    function Salvar() {
        if (Validar() === false) {
            return;
        }
        const senhaBase64 = base64.encode(senha);
        var data = new FormData();
        data.append("file", file);
        //Upload do certificado
        console.log(data);
        apiAdm.post('/entidade/uploadcertificado', data,
            {
                headers:
                {
                    // 'Content-Type': 'application/octet-stream',
                    'x-idEmpresa': localStorage.getItem('idEmpresa'),
                    'x-senha': '',
                    'x-senha64': senhaBase64,
                    'x-typeFile': 'cert',
                    'idGrupo': localStorage.getItem('idGrupo')
                }
            })
            .then((resp) => {
                //                 let today = new Date(vencto); 
                //                 console.log(vencto);
                //                 console.log(today);
                //                 let date = today.getFullYear() + "-" + parseInt(today.getMonth()+1) + "-" + today.getDate() + " " +
                //                            today.getHours() + ":" + today.getMinutes() + ":00";
                console.log('Vencto: ', vencto);
                //Salvar dados do certificado

                let json = {
                    senha: senhaBase64,
                    certRazao: certNome,
                    certDtVencto: vencto
                };

                apiAdm.put('/entidade/' + localStorage.getItem('idEmpresa'), json)
                    .then((resp) => {
                        SweetAlertSuccess({ texto: 'Certificado salvo com sucesso.' });
                        window.history.back();
                    })
                    .catch((erro) => {
                        console.log('Erro empresa: ' + erro);
                        SweetAlertError({ texto: 'Erro ao salvar Certificado.' })
                    });
            })
            .catch((erro) => {
                console.log('Erro empresa: ' + erro);
                SweetAlertError({ texto: 'Erro ao fazer o upload do Certificado' })
            });

    };

    return <>
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0"></div>
                <div className="row">
                    <div className="col-md-10 py-3">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="text-muted mb-3">Configuração do Certificado Digital - A1</h5>
                                <div className="row">
                                    <div className="col-xl-12">
                                        <br></br>
                                        <div className="row">
                                            <div className="card mb-g col-sm-12" id="A1">
                                                <div className="card-body p-3">
                                                    <div className="row">
                                                        <div className="form-group col-sm-7">

                                                            <div className="custom-file">
                                                                <input type="file" className="custom-file-input"
                                                                    id="customFile" accept=".pfx" onChange={handleFileUpload} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <br></br>
                                                    <div className="row mb-3">
                                                        <div className="form-group col-sm-3">
                                                            <label for="numeroNfe" className="form-label">Senha</label>
                                                            <input type="password" className="form-control" onChange={(e) => setSenha(e.target.value)} />
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <button type="button"
                                                                style={{ marginTop: "28px" }}
                                                                onClick={() => Testar()}
                                                                className="btn btn-block btn-primary">
                                                                Validar Certificado
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="row mb-3">
                                            <div className="col-sm-12">
                                                <h4>
                                                    Certificado Digital Configurado: <span
                                                        className="fw-300"></span>
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-9">
                                                <label className="form-label">Razão Social</label>
                                                <p>{certNome}</p>
                                            </div>
                                            <div className="col-sm-3">
                                                <label className="form-label">Data de Expiração</label>
                                                <p>{certData}</p>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div div className="row mb-3">
            <div className="btn-opcoes col-md-12" style={{ textAlign: 'right' }}>
                <button type="button" style={{ margin: 15 }} className="btn btn-outline-secondary"
                    onClick={() => Cancelar()}>
                    <FiXCircle /><span> Cancelar </span>
                </button>
                <button type="button" style={{ margin: 15 }} className="btn  btn-primary"
                    onClick={() => Salvar()}>
                    <FiSave /><span> Salvar </span>
                </button>

            </div>
        </div>

    </>
};

export default CrudCertificado;